import { useState, useEffect } from "react";
import { fieldType } from "../../../../types/form";
import { TooltipItem } from "src/utils/Tooltip";
import { InfoIcon } from "src/components/ui-icons/myTasks/info";

type Props = {
    dataField: fieldType;
    onChange: (data: any) => void;
    errors?: any;
    value: string;
}

function Input(props: Props) {
    const { dataField, onChange, errors, value } = props;

    const [disabledColor, setDisabledColor] = useState('#E5E7EB');

    useEffect(() => {
        if (dataField.hasOwnProperty('default') && dataField.default) {
            onChange(dataField.default);
        }
    }, [dataField]);

    useEffect(() => {
        if (dataField.key === 'SecurityRisk') {
            console.log('value: ', Number(value));
            if (Number(value) <= 10) {
                setDisabledColor('#C2F3D6')
            }
            if (value && (Number(value) > 10 && Number(value) <= 30)) {
                setDisabledColor('#FEF3C7')
            }
            if (value && Number(value) > 30) {
                setDisabledColor('#FEEBEB')
            }
        }
    }, [value, dataField]);

    return (
        <div className={`${dataField.width} mb-5`}>
            <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                <span className="flex flex-row items-center">{dataField.title} {dataField.noticeIcon && <TooltipItem wrapperClassName="flex w-[758px]" position="top-right" tooltipsComponent={dataField.notice} tooltipsText="">
                    <>&nbsp;&nbsp;<InfoIcon /></>
                </TooltipItem>}</span>
                {dataField.require && (
                    <div className="flex flex-row justify-between">
                        {Object.keys(errors).length > 0 && errors[dataField.key] && (
                            <span className="text-[#BA0C2F]">Заполните поле&nbsp;</span>
                        )}
                        <span className="text-[#BA0C2F]">*</span>
                    </div>
                )}
            </label>
            <div className="mt-2">
                <input
                    type="text"
                    autoComplete=""
                    value={dataField.default || (dataField.key === 'SecurityRisk' && `${value}%` || value)}
                    disabled={dataField.disabled}
                    onChange={onChange}
                    placeholder={dataField.placeholder}
                    style={{ backgroundColor: dataField.key === 'SecurityRisk' && disabledColor || (dataField.disabled && '#E5E7EB' || '#FFFFFF') }}
                    className={`block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 text-black outline-none shadow-custom placeholder:text-gray-400 bg-white disabled:cursor-not-allowed disabled:text-[#6B7280] disabled:bg-[#E5E7EB]`}
                />
            </div>
        </div>
    );
}

export default Input;





